module.exports = __webpack_public_path__ + "static/anne-paradis.8782cbac.webp";